import { useState } from 'react';
import UploadFile from '../../../components/ui/UploadFile';
import { OrderService } from '../../../core/services/order.service';
import { useAppDispatch } from '../../../libs/hook';
import { hideSpinner, showSpinner } from '../../../libs/features/spinnerSlice';
import { toast } from 'react-toastify';
import { FileService } from '../../../core/services/common/file.service';

type ImportFileModalProps = {
  onSubmit?: (event: any) => void;
  onClose?: (event?: any) => void;
};

export default function ExportFileModal(props: ImportFileModalProps) {
  const dispatch = useAppDispatch();
  const [images, setImages] = useState<any>();
  const [excelFile, setExcelFile] = useState<any>();

  const onChangeExcel = (event: any) => {
    setExcelFile(event.filesToAdd[0]);
  };

  const onSubmitForm = () => {
    if (!excelFile) {
      toast.error('Chưa có file excel');
      return;
    }
    dispatch(showSpinner());
    OrderService.createOrUpdateExportInfoByFile(excelFile, images)
      .finally(() => {
        setTimeout(() => {
          dispatch(hideSpinner());
        }, 500);
      })
      .then((res) => {
        if (!res.data.status) {
          const lines = res.data.message.split('\n');
          const formattedMessage = (
            <div>
              {lines.map((line: any, index: any) => (
                <>{line.trim()?.length > 0 && <div key={index}>- {line}</div>}</>
              ))}
            </div>
          );
          toast.error(formattedMessage);
          return;
        }
        props.onClose?.(true);
      });
  };

  const downloadFile = () => {
    dispatch(showSpinner());
    FileService.downloadExportTemplate()
      .finally(() => {
        setTimeout(() => {
          dispatch(hideSpinner());
        }, 500);
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));

        const link: any = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'mau-xuat-kho.xlsx');

        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
      });
  };

  return (
    <>
      <div className="modal-body">
        <div className="row">
          <div className="col-12 pt-3">
            <div className="mb-2 text-danger">Lưu ý nội dung file Excel:</div>
            <div>
              <ul>
                <li className='text-danger'>Mã đơn hàng là bắt buộc.</li>
                <li className='text-danger'>Loại hàng hóa là bắt buộc.</li>
                <li className='text-danger'>Mã khách hàng là bắt buộc.</li>
                <li className='text-danger'>Số điện thoại là bắt buộc</li>
                <li className='text-danger'>Mã nhân viên là bắt buộc</li>
                <li className='text-danger'>Số kiện là bắt buộc.</li>
                <li className='text-danger'>Biển số xe là bắt buộc.</li>
                <li className='text-danger'>Cửa khẩu là bắt buộc.</li>
                <li className='text-danger'>Loại xe là bắt buộc.</li>
                <li className='text-danger'>Điểm đến là bắt buộc.</li>
              </ul>
            </div>
          </div>
          <div className="col-12 py-3">
            <div className="text-heading mb-2 d-flex justify-content-between">
              <div>Tệp Excel</div>
              <div className="badge rounded-pill bg-primary cursor-pointer" onClick={downloadFile}>
                Tải file mẫu
              </div>
            </div>
            <UploadFile onChange={onChangeExcel} accept=".xlsx, .xls" multiple={false}></UploadFile>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-outline-secondary waves-effect" onClick={() => props.onClose?.(false)}>
          Hủy
        </button>
        <button type="button" className="btn btn-primary waves-effect waves-light" onClick={onSubmitForm}>
          Thêm
        </button>
      </div>
    </>
  );
}
